import {
  Button,
  Card,
  Col,
  Drawer,
  Form,
  Input,
  InputNumber,
  message,
  Row,
  Select,
  Space,
  Spin,
  Table,
  Typography,
  Upload,
} from "antd"
import { addDoc, collection, onSnapshot, query, serverTimestamp, where } from "firebase/firestore"
import React, { useEffect, useState } from "react"
import { db, storage } from "../../../firebase/config"
import { PlusCircleOutlined, UploadOutlined } from "@ant-design/icons"
import { useCollection } from "../../../hooks/useCollection"
import { ref as storageRef, uploadBytes } from "firebase/storage"
import useSerachKnifeWithButton from "../../../hooks/useSerachKnifeWithButton"
// import axios from "axios"

const { Link, Title, Text } = Typography
const { TextArea } = Input

export default function NewArsomaPlateModal(props) {
  const { data: clientList, loading: clientListLoading } = useCollection("clients")

  //props for check if its coming from order details
  const { comingFromOrderDetails, dataDetails, selectedKnife } = props

  //gettings knives
  const { knifeData, knifeLoading, fetchDataWithSearch } = useSerachKnifeWithButton()

  //init form
  const [form] = Form.useForm()

  //technical page file
  const [filesList, setFilesList] = useState([])

  //create button loading
  const [buttonLoading, setButtonLoading] = useState(false)

  //loading
  const [loading, setLoading] = useState(false)

  //knife list
  const [knifeWidth, setKnifeWidth] = useState(0)
  const [knifeHeight, setKnifeHeight] = useState(0)
  const [knifeRange, setKnifeRange] = useState(0)

  //product list
  const [productList, setProductList] = useState([])
  const [productListLoading, setProductListLoading] = useState(false)

  //main data object
  const [dataObject, setDataObject] = useState({
    clientId: null,
    client: null,
    code: null,
    codeNumber: null,
    codePrefix: null,
    important: "none",
    knifeNumber: null,
    knifeCode: null,
    knifeRows: null,
    layoutDesign: null,
    product: null,
    productId: null,
    width: null,
    height: null,
    rows: null,
    designerProductName: null,
    isMultiple: false,
    plateLocation: null,
    machine: "arsoma",
    plateRef: "arsomaPlateList",
    storageRef: "arsomaPlates",
    paid: false,
    plateStatus: "new",
  })

  const [openDrawer, setOpenDrawer] = useState(false)

  const [fileList, setFileList] = useState([])
  const [folderName, setFolderName] = useState("")

  const plateFolder = "arsomaPlates"

  const beforeUpload = (file) => {
    setFileList([...fileList, file])
    // Prevent automatic upload
    return false
  }

  const showDrawer = () => {
    setOpenDrawer(true)
  }

  const onClose = () => {
    setOpenDrawer(false)
  }

  const onFinish = (values) => {
    console.log("Success:", values)
    createNewPlate()
  }
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo)
  }

  //SECTION : COMING FROM ORDER DETAILS
  useEffect(() => {
    if (openDrawer && comingFromOrderDetails) {
      setDataObject({
        clientId: dataDetails.clientId,
        client: dataDetails.client.client,
        product: dataDetails.selectedProduct.product.productName,
        productId: dataDetails.selectedProduct.id,
        plateLocation: "Kengarags",
        rows: selectedKnife.rowss,
      })
      console.log("last", selectedKnife)

      // Set the initial value of the "client" field
      form.setFieldsValue({
        client: dataDetails.client.client,
        product: dataDetails.selectedProduct.product.productName,
        plateLocation: "Kengarags",
        rows: selectedKnife.rowss,
      })

      //handles knife
      handleKnifeSelect(selectedKnife)
      setKnifeWidth(selectedKnife.width)
      setKnifeHeight(selectedKnife.height)
    }
  }, [dataDetails, openDrawer, form, comingFromOrderDetails, selectedKnife])

  useEffect(() => {
    setProductListLoading(true)
    const colRef = collection(db, "priceCalculation")
    let q = query(colRef, where("clientId", "==", dataObject.clientId))

    const unsubscribe = onSnapshot(q, (snapshot) => {
      let results = []
      snapshot.docs.forEach((doc) => {
        const data = doc.data()
        results.push({ ...data, key: doc.id, id: doc.id })
      })
      // sort the results based on the arsomaSequence state
      setProductList(results)
      setProductListLoading(false)
    })

    return () => unsubscribe()
  }, [dataObject.clientId])

  const handleUpload = async (fileList, folderName, plateFolder) => {
    const uploadPromises = fileList.map((file) => {
      return new Promise((resolve, reject) => {
        const fileRef = storageRef(storage, `${plateFolder}/${folderName}/${file.name}`) // Create a reference to the file location
        uploadBytes(fileRef, file) // Upload the file
          .then((snapshot) => {
            message.success(`${file.name} uploaded successfully`)
            resolve(snapshot)
          })
          .catch((error) => {
            message.error(`${file.name} upload failed: ${error.message}`)
            reject(error)
          })
      })
    })

    await Promise.all(uploadPromises)
  }

  const createNewPlate = async () => {
    try {
      setButtonLoading(true)
      setLoading(true) // Set loading state to true when the function starts executing

      // First, upload all files
      await handleUpload(fileList, folderName, plateFolder)

      console.log(dataObject)

      // Once all uploads are complete, add the document
      const collectionRef = collection(db, "arsomaPlateList")
      await addDoc(collectionRef, {
        ...dataObject,
        created: serverTimestamp(),
        updated: serverTimestamp(),
      })
      message.success("New plate added!")
      setFileList([]) // Clear the file list once upload and document creation are done
    } catch (error) {
      console.error("Error:", error)
      message.error(error.message)
    } finally {
      setFilesList([])
      setOpenDrawer(false)
      form.resetFields()
      setButtonLoading(false)
      setLoading(false) // Reset loading state to false once everything is done
    }
  }

  //handle select for client
  const handleClientSelect = (value, option) => {
    setDataObject((prevDataObject) => ({
      ...prevDataObject,
      client: option.client,
      clientId: option.id,
    }))
    form.resetFields(["product"])
  }

  //handle select for product
  const handleProductSelect = (value, option) => {
    console.log(option)
    setDataObject((prevDataObject) => ({
      ...prevDataObject,
      product: value,
      productId: option.id,
    }))
  }
  //handlePlateStatus
  const handlePlateStatus = (value) => {
    setDataObject((prevDataObject) => ({
      ...prevDataObject,
      plateStatus: value,
    }))
  }

  //handle change for code input
  const handleCodeChange = (value) => {
    const totalCode = "POLI" + value
    setDataObject((prevDataObject) => ({
      ...prevDataObject,
      code: "POLI" + value,
      codeNumber: value,
      codePrefix: "POLI",
    }))
    setFolderName(totalCode)
  }

  //get last knife plate code
  const buttonForLast = () => <Link onClick={getLastCode}>Get last</Link>

  const getLastCode = () => {
    setDataObject((prevDataObject) => ({
      ...prevDataObject,
      codeNumber: props.lastPlate.codeNumber + 1,
      code: "POLI" + (props.lastPlate.codeNumber + 1).toString().padStart(4, "0"),
      codePrefix: "POLI",
    }))
    setFolderName("POLI" + (props.lastPlate.codeNumber + 1).toString().padStart(4, "0"))
    form.setFieldValue("code", (props.lastPlate.codeNumber + 1).toString().padStart(4, "0"))
  }

  //handle knife Select
  const handleKnifeSelect = (value) => {
    //strip the code into a number
    const knifeCode = value.code
    const pureNumber = knifeCode.replace(/\D/g, "")
    const numericValuePureNumber = parseInt(pureNumber)
    setDataObject((prevDataObject) => ({
      ...prevDataObject,
      knifeCode: value.code,
      knifeRows: value.rowss,
      knifeNumber: numericValuePureNumber,
      width: value.width,
      height: value.height,
    }))
  }

  //handles plate rows
  const handlePlateRows = (value) => {
    setDataObject((prevDataObject) => ({
      ...prevDataObject,
      rows: value,
    }))
  }

  //handles layout name
  const handleLayoutName = (event) => {
    const value = event.target.value
    setDataObject((prevDataObject) => ({
      ...prevDataObject,
      layoutDesign: value,
    }))
  }

  //handle comment
  const handleComment = (event) => {
    const value = event.target.value
    setDataObject((prevDataObject) => ({
      ...prevDataObject,
      important: value,
    }))
  }

  //handle designer name
  const handleDesignerName = (event) => {
    const value = event.target.value
    setDataObject((prevDataObject) => ({
      ...prevDataObject,
      designerProductName: value,
    }))
  }

  //handles plate location
  const handlePlateLocation = (value) => {
    setDataObject((prevDataObject) => ({
      ...prevDataObject,
      plateLocation: value,
    }))
  }

  //knife search
  const handleKnifeSearch = () => {
    // Call fetchDataWithSearch with the necessary parameters
    fetchDataWithSearch(null, knifeWidth, knifeHeight, knifeRange, "any", 0, "Arsoma")
  }

  //knife choosing
  const returnKnifeSelect = () => {
    //knife columns table
    const knifeCols = [
      {
        title: "Code",
        dataIndex: "code",
        align: "center",
      },
      {
        title: "Width",
        dataIndex: "width",
        align: "center",
      },
      {
        title: "Height",
        dataIndex: "height",
        align: "center",
      },
      {
        title: "Rows",
        dataIndex: "rowss",
        align: "center",
      },
      {
        title: "Form Type",
        dataIndex: "TypeOfForm",
        align: "center",
      },
      {
        title: "Action",
        dataIndex: "id",
        align: "center",
        render: (value, record) => {
          return (
            <>
              <Button onClick={() => handleKnifeSelect(record)}>Select this</Button>
            </>
          )
        },
      },
    ]

    return (
      <div>
        <Card
          title={"Selected Knife : " + dataObject.knifeCode}
          extra={
            <Space>
              <InputNumber
                style={{ width: 100 }}
                value={knifeWidth}
                onChange={setKnifeWidth}
                min={0}
                placeholder="width"
                prefix={`W: `}
                size="small"
              />
              <InputNumber
                style={{ width: 100 }}
                value={knifeHeight}
                onChange={setKnifeHeight}
                min={0}
                placeholder="height"
                size="small"
                prefix={`H: `}
              />
              <InputNumber
                style={{ width: 100 }}
                value={knifeRange}
                onChange={setKnifeRange}
                min={0}
                placeholder="range"
                prefix={`Range: `}
                size="small"
              />
              <Button onClick={() => handleKnifeSearch()} type="primary" size="small">
                Search
              </Button>
            </Space>
          }
          size="small"
          style={{
            width: "100%",
          }}>
          <Table
            size="small"
            bordered
            pagination={{ defaultPageSize: "5", showSizeChanger: true }}
            rowKey={(record) => record.id}
            loading={knifeLoading}
            columns={knifeCols}
            dataSource={knifeData && knifeData}
          />
        </Card>
      </div>
    )
  }

  //returns uploading state
  const returnLoadingState = () => {
    if (loading) {
      return (
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: "rgba(255,255,255,0.9)", // white with 50% opacity
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 15,
          }}>
          <div>
            <Row>
              <Col span={24}>
                <Title>
                  <Spin /> Files being uploaded
                </Title>
              </Col>
            </Row>

            {filesList &&
              filesList.map((file) => (
                <div key={file.uid}>
                  <Text italic>{file.name}</Text>
                </div>
              ))}
          </div>
        </div>
      )
    }
  }

  return (
    <>
      <Button icon={<PlusCircleOutlined />} onClick={showDrawer}></Button>
      <Drawer
        width={700}
        title="New arsoma plate"
        placement="right"
        onClose={onClose}
        open={openDrawer}>
        {returnLoadingState()}

        <Form
          form={form}
          name="clientForm"
          initialValues={{
            remember: true,
          }}
          layout="vertical"
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
          style={{ width: "100%" }}>
          <Form.Item
            label="Select client"
            name="client"
            rules={[
              {
                required: true,
                message: "Please input your field!",
              },
            ]}>
            <Select
              showSearch
              placeholder="Select client"
              optionFilterProp="children"
              onChange={handleClientSelect}
              fieldNames={{ label: "client", value: "id", key: "id" }}
              loading={clientListLoading}
              filterOption={(input, option) =>
                (option?.client ?? "").toLowerCase().includes(input.toLowerCase())
              }
              options={clientList && clientList}
            />
          </Form.Item>
          <Form.Item
            label="Select product"
            name="product"
            rules={[
              {
                required: true,
                message: "Please input your field!",
              },
            ]}>
            <Select
              showSearch
              placeholder="Select product"
              onChange={handleProductSelect}
              loading={productListLoading}
              filterOption={(input, option) => {
                return option.children.toLowerCase().includes(input.toLowerCase())
              }}>
              {productList &&
                productList.map((option, index) => (
                  <Select.Option key={index} id={option.id} value={option?.product?.productName}>
                    {option?.product?.productName}
                  </Select.Option>
                ))}
            </Select>
          </Form.Item>
          <Form.Item label="Designer product name (optional)" name="designerProductName">
            <Input
              placeholder="Write your own product slogan"
              style={{ width: "100%" }}
              onChange={handleDesignerName}
            />
          </Form.Item>
          <Form.Item
            label="Plate Code"
            name="code"
            rules={[
              {
                required: true,
                message: "Please input your field!",
              },
            ]}>
            <InputNumber
              style={{ width: "100%" }}
              addonAfter={buttonForLast()}
              prefix="POLI"
              min={0}
              onChange={handleCodeChange}
            />
          </Form.Item>
          <Form.Item label="Select Knife" name="knife">
            {returnKnifeSelect()}
          </Form.Item>
          <Form.Item
            label="Plate rows"
            name="rows"
            rules={[
              {
                required: true,
                message: "Please input your field!",
              },
            ]}>
            <InputNumber style={{ width: "100%" }} min={0} max={100} onChange={handlePlateRows} />
          </Form.Item>
          <Form.Item
            label="Layout Name"
            name="layoutName"
            rules={[
              {
                required: true,
                message: "Please input your field!",
              },
            ]}>
            <Input style={{ width: "100%" }} onChange={handleLayoutName} />
          </Form.Item>
          <Form.Item
            label="Plate Location"
            name="plateLocation"
            rules={[
              {
                required: true,
                message: "Please input your field!",
              },
            ]}>
            <Select
              onChange={handlePlateLocation}
              options={[
                {
                  value: "Not Ordered",
                  label: "Not Ordered",
                },
                {
                  value: "Ordered",
                  label: "Ordered (in proccess)",
                },
                {
                  value: "Kengarags",
                  label: "At Kengarags",
                },
                {
                  value: "Visvaldis",
                  label: "At Visvaldis",
                },
              ]}
            />
          </Form.Item>
          <Form.Item
            label="Platus Status"
            name="plateStatus"
            rules={[
              {
                required: true,
                message: "Please input your field!",
              },
            ]}>
            <Select
              onChange={handlePlateStatus}
              options={[
                {
                  value: "used",
                  label: "used",
                },
                {
                  value: "new",
                  label: "new",
                },
              ]}
            />
          </Form.Item>
          <Form.Item
            label="All files regarding this plate"
            name="filesList"
            rules={[
              {
                required: true,
                message: "Please input your field!",
              },
            ]}>
            <Upload
              beforeUpload={beforeUpload}
              fileList={fileList}
              onRemove={(file) => {
                setFileList(fileList.filter((item) => item.uid !== file.uid))
              }}>
              <Button icon={<UploadOutlined />}>Select Files</Button>
            </Upload>
          </Form.Item>
          <Form.Item
            label="Important"
            name="important"
            rules={[
              {
                message: "Please input your field!",
              },
            ]}>
            <TextArea rows={4} style={{ width: "100%" }} onChange={handleComment} />
          </Form.Item>
          <Form.Item>
            <Button
              disabled={dataObject.knifeNumber === null ? true : false}
              loading={buttonLoading}
              block
              type="primary"
              htmlType="submit">
              Create plate
            </Button>
          </Form.Item>
        </Form>
      </Drawer>
    </>
  )
}
